export default "__VITE_ASSET__DkDQ_NDu__"